/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React, { useId } from 'react';
import { Tooltip } from 'react-tooltip';
import ver from '../../../images/icons/ver.png';
import styles from './ToolTip.module.scss';

const ToolTipIcon = ({ isSmall }) => {
  const uniqueId = useId();

  return (
    <>
      <div className={styles.tick}>
        <div className={styles.tooltip}>
          <img
            data-tip="Verified by owner"
            data-for={`tooltip-${uniqueId}`}
            alt=""
            src={ver}
            className={isSmall ? styles.small : null}
          />
        </div>
      </div>
      <Tooltip
        effect='solid'
        id={`tooltip-${uniqueId}`}
        backgroundColor='#7fa73c'
      />
    </>
  );
}

export default ToolTipIcon;